import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Address } from '../../../../../lib/models/api/address.model';
import { Associate } from '../../../../../lib/models/api/associate.model';

@Component({
  selector: 'boi-form-listview',
  templateUrl: './form-listview.component.html',
  styleUrls: ['./form-listview.component.scss']
})
export class FormListviewComponent {
  @Input() dataList: any;
  @Input() selectedValue: any;
  @Output() readonly selectedValueChange: EventEmitter<any> = new EventEmitter<any>();

  onSelectedValueChange(dataItem): void {
    this.selectedValue = dataItem;
    this.selectedValueChange.emit(this.selectedValue);
  }

  public getDataItemDisplayName(dataItem: any): string {
    let displayName: string;
    if (dataItem instanceof Associate) {
      displayName = this.formatSolicitorAddress(dataItem);
    } else if (dataItem instanceof Address) {
      displayName = this.formatAddress(dataItem);
    }

    return displayName;
  }

  private formatAddress(address: Address): string {
    let displayName = '';

    displayName += address.AddressLine1 ? `${address.AddressLine1} ` : '';
    displayName += address.AddressLine2 ? `${address.AddressLine2} ` : '';
    displayName += address.AddressLine3 ? `${address.AddressLine3} ` : '';
    displayName += address.County ? `${address.County}` : '';

    return displayName;
  }

  private formatSolicitorAddress(associate: Associate): string {
    const displayValues = new Array<string>();

    displayValues.push(associate.AddressLine1 ? associate.AddressLine1 : undefined);
    displayValues.push(associate.AddressLine2 ? associate.AddressLine2 : undefined);
    displayValues.push(associate.AddressLine3 ? associate.AddressLine3 : undefined);
    displayValues.push(associate.County ? associate.PostCode : '');

    const displayName = displayValues.filter((v) => v !== undefined).join(', ');

    return displayName;
  }
}
